// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const DeliveryServiceabilityStatus = {
  Deliverable: {
    Name: 'Deliverable',
    Value: 'deliverable',
  },
  OutsideDeliveryArea: {
    Name: 'Outside Delivery Area',
    Value: 'outside_delivery_area',
  },
  AddressNotVerified: {
    Name: 'Address Not Verified',
    Value: 'address_not_verified',
  },
} as const

export type DeliveryServiceabilityStatusValue =
  (typeof DeliveryServiceabilityStatus)[keyof typeof DeliveryServiceabilityStatus]['Value']
